import API_BASE from '../../utils/api';
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Sidebar from '../../components/Sidebar';
import ProfileDropdown from '../../components/ProfileDropdown';

const Events = () => {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);

  const eventTypeColors = {
    exam: 'bg-red-100 text-red-800',
    holiday: 'bg-green-100 text-green-800',
    meeting: 'bg-yellow-100 text-yellow-800',
    sports: 'bg-blue-100 text-blue-800',
    cultural: 'bg-purple-100 text-purple-800',
    field_trip: 'bg-orange-100 text-orange-800',
    other: 'bg-gray-100 text-gray-800'
  };

  useEffect(() => {
    fetchEvents();
  }, []);

  const fetchEvents = async () => {
    try {
      const res = await axios.get(`${API_BASE}/events?upcoming=true`);
      setEvents(res.data);
    } catch (err) {
      console.error('Error fetching events:', err);
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (d) => new Date(d).toLocaleDateString('en-IN', {
    weekday: 'long', year: 'numeric', month: 'long', day: 'numeric'
  });

  const daysUntil = (d) => {
    const diff = Math.ceil((new Date(d) - new Date()) / (1000 * 60 * 60 * 24));
    if (diff === 0) return 'Today';
    if (diff === 1) return 'Tomorrow';
    return `In ${diff} days`;
  };

  return (
    <div className="flex h-screen bg-gray-100">
      <Sidebar />
      <div className="flex-1 overflow-auto">
        <nav className="bg-white shadow-sm sticky top-0 z-10">
          <div className="flex justify-between items-center px-6 py-3">
            <h1 className="text-xl font-semibold text-gray-800">Events</h1>
            <ProfileDropdown />
          </div>
        </nav>

        <div className="p-6">
          <h2 className="text-2xl font-bold text-gray-900 mb-6">Upcoming Events</h2>

          {loading ? (
            <div className="flex justify-center py-12">
              <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-600"></div>
            </div>
          ) : events.length === 0 ? (
            <div className="bg-white rounded-lg shadow p-8 text-center text-gray-500">
              No upcoming events.
            </div>
          ) : (
            <div className="space-y-4">
              {events.map((event) => (
                <div key={event._id} className="bg-white rounded-lg shadow p-5 border-l-4 border-indigo-500">
                  <div className="flex justify-between items-start">
                    <div className="flex-1">
                      <div className="flex items-center gap-3 mb-2">
                        <h4 className="font-semibold text-gray-900 text-lg">{event.title}</h4>
                        <span className={`px-2 py-1 rounded-full text-xs font-medium ${eventTypeColors[event.eventType] || eventTypeColors.other}`}>
                          {event.eventType.replace('_', ' ')}
                        </span>
                        {event.isSchoolWide && (
                          <span className="bg-indigo-100 text-indigo-700 px-2 py-1 rounded-full text-xs">School-wide</span>
                        )}
                      </div>
                      <p className="text-gray-600 mb-2">{event.description}</p>
                      <div className="flex items-center gap-4 text-sm text-gray-500">
                        <span>📅 {formatDate(event.eventDate)}</span>
                        <span className="text-indigo-600 font-medium">{daysUntil(event.eventDate)}</span>
                        {event.createdBy && <span>👨‍🏫 {event.createdBy.name}</span>}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Events;
